import ChartOfAccounts from "../Accounts/ChartOfAccounts";

export default ChartOfAccounts;
